var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "495.000000pt",
    viewBox: "0 0 512.000000 495.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,495.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3001 3974 c-236 -63 -440 -307 -441 -527 0 -81 5 -84 93 -67 90 17 178 64 255 136 113 105 178 240 189 391 6 83 6 83 -18 82 -13 0 -48 -7 -78 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2025 3324 c-163 -36 -316 -142 -411 -286 -93 -140 -134 -291 -134 -497 0 -320 108 -646 306 -926 195 -276 325 -343 526 -269 208 76 210 76 303 76 72 0 104 -5 163 -26 226 -82 214 -78 288 -74 126 8 216 72 345 246 89 120 156 236 197 342 49 123 49 115 -2 141 -134 67 -252 214 -291 366 -19 73 -19 232 0 303 32 121 131 264 229 331 20 13 36 28 36 33 0 5 -33 41 -72 80 -121 119 -264 176 -444 176 -102 0 -179 -17 -324 -74 -154 -60 -148 -61 -411 33 -107 39 -206 47 -304 25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.05ae1377ed6a77197e12e9166131fed4.svg";
export { ForwardRef as ReactComponent };